"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TextFilter_1 = __importDefault(require("../TextFilter"));
const SingleSelectFilter_1 = __importDefault(require("../SingleSelectFilter"));
const DateRangeFilter_1 = __importDefault(require("../DateRangeFilter"));
const MultiSelectFilter_1 = __importDefault(require("../MultiSelectFilter"));
const SingleSelectTypeaheadFilter_1 = __importDefault(require("../SingleSelectTypeaheadFilter"));
const DEFAULT_FILTERS = {
    entityid: TextFilter_1.default,
    string: TextFilter_1.default,
    daterange: DateRangeFilter_1.default,
    singleselect: SingleSelectFilter_1.default,
    multiselect: MultiSelectFilter_1.default,
    singleselecttypeahead: SingleSelectTypeaheadFilter_1.default
};
exports.default = DEFAULT_FILTERS;
//# sourceMappingURL=DefaultFilters.js.map